import React, { useContext, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import DataTableComponent from "../src/components/DataTableComponent.jsx";
import ToastLayout from "../src/components/ToastLayout.jsx";
import NotificationDashboard from "../src/components/NotificationDashboard.jsx";
import { ImageContext } from "../src/page/ApiContext.jsx";
import Layout from "../src/components/Layout.jsx";
import Login from "../src/page/Login.jsx";
import Protected from "../src/components/Protected.jsx";
import AdminDashboard from "../src/page/AdminDashboard.jsx";
import NotAuthenticated from "../src/components/NotAuthenticated.jsx";
import { getCookie } from "../src/components/Cookie.jsx";
import ResetPassword from "../src/page/Reset_pwd.jsx"

export default function App() {
  const token = getCookie("sqa_token");

  const {
    dashboardIds,
    setDashboardIds,
    functionalityIds,
    setFunctionalityIds,
    userRoleId,
    setUserRoleId,
    roleActive,
    setRoleActive,
  } = useContext(ImageContext);

  // console.log("role,status", roleActive);

  useEffect(() => {
    getRoleDetails();
  }, [roleActive]);

  const getRoleDetails = async () => {
    try {
      const url = `/sqa/api/get_role_specifications_details`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      const { dashboard_ids, functionality_ids, role_id } = data.result[0];

      setDashboardIds(dashboard_ids);
      setFunctionalityIds(functionality_ids);
      setUserRoleId(role_id);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Router> 
      <ToastLayout>
        <Routes>
          <Route path="/auth/reset-pwd/:token" element={<ResetPassword />} />
          <Route path="/auth/user-info" element={<Login />} />
          <Route
            path="/"
            element={
              token ?
              <Navigate to="/home" replace />:
              <Navigate to="/auth/user-info" replace /> 
            }
          />
          <Route
            path="/home"
            element={token ?
              <Layout>
                <Protected User={DataTableComponent} />
              </Layout> : <Navigate to="/auth/user-info" replace />
            }
          />
          <Route
            path="/notification"
            element={token?
              <Layout>
                <Protected User={NotificationDashboard} />
              </Layout>: <Navigate to="/auth/user-info" replace />
            }
          />

          {dashboardIds.includes(101) && (
            <Route
              path="/adminDashboard"
              element={token?
                <Layout>
                  <Protected User={AdminDashboard} />
                </Layout>: <Navigate to="/auth/user-info" replace />
              }
            />
          )}

          <Route path="*" element={<NotAuthenticated />} />

          {/* <Route
              path="/profile"
              element={
                <DashboardLayout>
                  <UserProtected User={UserProfile} />
                </DashboardLayout>
              }
            /> */}
          {/* <Route path="/request" element = {<Layout><LayoutModalDialog /></Layout>} /> */}
        </Routes>
      </ToastLayout>
    </Router>
  );
}
